import styled, { css } from 'styled-components';
import { StyledSponsorTagProps } from '../typings';
import { themeToken } from '../../utils/cpds-utils';

const SponsorTagBrandText = styled.p.attrs({
  className: 'cpds-meta-roman-book-10',
})`
  line-height: 10px !important;
  font-weight: 400 !important;
`;

const SponsorTagBrandLogo = styled.img`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      width: ${token.sponsor_tag_brand_logo_width};
      max-width: ${token.sponsor_tag_brand_logo_max_width};
      max-height: ${token.sponsor_tag_brand_logo_max_height};
      height: auto;
    `;
  }}
`;

const SponsorTagWrapper = styled.div<StyledSponsorTagProps>`
  ${({
    theme: {
      styles: { cpds },
    },
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    return css`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: fit-content;
      column-gap: ${token.spacing.space_8};
      ${SponsorTagBrandText} {
        color: ${token.sponsor_tag_color};
      }
      ${(props) => props?.styleOverrides}
    `;
  }}
`;

export { SponsorTagWrapper, SponsorTagBrandText, SponsorTagBrandLogo };
